module.exports = __webpack_public_path__ + "img/Part2.d4463ab.png";